import { gql, useQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';

interface DomainConfigVars {
  domainIdentifier: string;
}
interface DomainConfigData {
  domain: {
    rawConfig: AnyObject;
  };
}
const GQL_DOMAIN_CONFIG = gql`
  query getDomainConfig($domainIdentifier: String!, $piezoArtifacts: JSON) {
    domain(domainIdentifier: $domainIdentifier, piezoArtifacts: $piezoArtifacts) {
      rawConfig
    }
  }
`;

export const useDomainConfigQuery = (vars: DomainConfigVars) => {
  return useQuery<DomainConfigData, Record<string, unknown>>(GQL_DOMAIN_CONFIG, {
    variables: { ...vars },
    // piezoLink auto-derives + signs the migrated tools this query selects (signing/fieldRegistry)
    // and injects the $piezoArtifacts map; the resolvers run those exact params.
  });
};
